import Vuex from 'vuex'
import Vue from 'vue'
import snackbar from './modules/snackbar'
import pageLoader from './modules/pageLoader'
import userModule from './modules/user'
import assetModule from './modules/asset'
import overviewModule from './modules/overview'
import accountModule from './modules/account'
import channelModule from './modules/channel'
import connectorModule from './modules/connector'
import filesModule from './modules/files'
import importModule from './modules/import'
import metadataModule from './modules/metadata'
import uploadModule from './modules/upload'
import scheduleModule from './modules/schedule'
import mediaSourceModule from './modules/mediaSources'
import distributionModule from './modules/distributions'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    snackbar,
    pageLoader,
    users: userModule,
    assets: assetModule,
    overviews: overviewModule,
    accounts: accountModule,
    channels: channelModule,
    connectors: connectorModule,
    files: filesModule,
    import: importModule,
    metadata: metadataModule,
    upload: uploadModule,
    schedule: scheduleModule,
    mediaSources: mediaSourceModule,
    distributions: distributionModule,
  },
})
